import { render, staticRenderFns } from "./ZoneTable.vue?vue&type=template&id=62a0afc6"
import script from "./ZoneTable.vue?vue&type=script&lang=js"
export * from "./ZoneTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports